import { toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../static/img/illustrations/Folder.svg'


const _withScopeId = n => (_pushScopeId("data-v-3cd5074a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { ref: "attachmentForm" }
const _hoisted_2 = { class: "column q-gutter-y-sm" }
const _hoisted_3 = {
  key: 0,
  class: "q-mt-lg"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mandatory" }, null, -1))
const _hoisted_5 = ["alt"]
const _hoisted_6 = {
  key: 1,
  class: "q-mt-lg"
}
const _hoisted_7 = { class: "row items-start justify-between" }
const _hoisted_8 = { class: "text-negative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_file_uploader = _resolveComponent("file-uploader")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_iuf_select = _resolveComponent("iuf-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_list, { class: "column q-mt-lg" }, {
      default: _withCtx(() => [
        _createElementVNode("span", _mergeProps(_ctx.TEXT_FORM_FIELD_LABEL, { class: "q-mb-sm" }), _toDisplayString(_ctx.t('FORMAT.LABEL')), 17),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatOptions, (option, index) => {
            return (_openBlock(), _createBlock(_component_q_radio, _mergeProps({
              val: option,
              key: index,
              dense: "",
              onClick: ($event: any) => (_ctx.updateFormat(option))
            }, _ctx.RADIO_PROPS, { "model-value": _ctx.format }), {
              default: _withCtx(() => [
                _createElementVNode("div", _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), _toDisplayString(_ctx.t(_ctx.AgreementDocumentFormatLabel.get(option))), 17)
              ]),
              _: 2
            }, 1040, ["val", "onClick", "model-value"]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    (_ctx.format === _ctx.AgreementDocumentFormatValues.FILE)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _mergeProps(_ctx.TEXT_FORM_FIELD_LABEL, { class: "q-mb-sm" }), [
            _createTextVNode(_toDisplayString(_ctx.t('FILE.CAP.SING')) + " ", 1),
            _hoisted_4
          ], 16),
          _createVNode(_component_file_uploader, {
            "file-uploaded": _ctx.file?.name ?? _ctx.fileName,
            label: _ctx.t('FILE_LABEL'),
            "browse-btn": "",
            class: "agreement-file-uploader",
            accept: _ctx.SUPPORTED_FILES,
            "max-file-size": _ctx.MAX_FILE_SIZE,
            onUpload: _ctx.selectFile,
            ref: "uploader"
          }, {
            image: _withCtx(() => [
              (_ctx.file !== null)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    alt: _ctx.t('FILE.CAP.SING'),
                    class: "q-mb-md",
                    src: _imports_0
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["file-uploaded", "label", "accept", "max-file-size", "onUpload"])
        ]))
      : (_ctx.format === _ctx.AgreementDocumentFormatValues.LINK)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_q_input, _mergeProps({
                placeholder: _ctx.t('LINK.URL.PLACEHOLDER'),
                rules: [(val) => (val && val.length) > 0 && _ctx.STRING_REGEX.URL.test(val)],
                "label-slot": "",
                class: "link-input"
              }, _ctx.INPUT_LG, {
                "onUpdate:modelValue": _ctx.updateLink,
                "model-value": _ctx.linkUrl
              }), {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('LINK.CAP.SING')) + " ", 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t('MANDATORY')), 1)
                ]),
                error: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: _ctx.ICONS_NAME.WARNING_SOLID
                  }, null, 8, ["name"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t('LINK.CREATION_ERROR_URL')), 1)
                ]),
                _: 1
              }, 16, ["placeholder", "rules", "onUpdate:modelValue", "model-value"]),
              _createVNode(_component_iuf_select, _mergeProps({
                label: _ctx.t('LINK.TYPE.LABEL'),
                "option-label": _ctx.getTypeLabel,
                options: _ctx.externalLinkTypeOptions,
                "placeholder-value": _ctx.t('LINK.TYPE.PLACEHOLDER'),
                "label-slot": "",
                mandatory: "",
                "onUpdate:modelValue": _ctx.updateType,
                "selected-item-slot": ""
              }, _ctx.SELECT_SINGLE_LG, { "model-value": _ctx.linkType }), {
                option: _withCtx((scope) => [
                  _createVNode(_component_q_item_section, { side: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, _mergeProps({
                        name: _ctx.getTypeIcon(scope.opt)
                      }, _ctx.ICON_PROPS.BTN_LG), null, 16, ["name"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getTypeLabel(scope.opt)), 1)
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                "selected-item": _withCtx((scope) => [
                  _createVNode(_component_q_item, { dense: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, _mergeProps({
                            name: _ctx.getTypeIcon(scope.opt)
                          }, _ctx.ICON_PROPS.BTN_LG), null, 16, ["name"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_item_section, { class: "no-break" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getTypeLabel(scope.opt)), 1)
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 16, ["label", "option-label", "options", "placeholder-value", "onUpdate:modelValue", "model-value"])
            ]),
            _createVNode(_component_q_input, _mergeProps({
              class: "q-mt-lg",
              placeholder: _ctx.t('LINK.LABEL.PLACEHOLDER'),
              rules: [(val) => _ctx.isLabelValid()]
            }, _ctx.INPUT_LG, {
              label: _ctx.t('LINK.LABEL.LABEL'),
              "onUpdate:modelValue": _ctx.updateLabel,
              "model-value": _ctx.linkLabel
            }), {
              error: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: _ctx.ICONS_NAME.WARNING_SOLID
                }, null, 8, ["name"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('LINK.LABEL.VALIDATION', { x: _ctx.MAX_LENGTH.EXTERNAL_LINK.LABEL })), 1)
              ]),
              _: 1
            }, 16, ["placeholder", "rules", "label", "onUpdate:modelValue", "model-value"])
          ]))
        : _createCommentVNode("", true)
  ], 512))
}